<template>
  <section id="page" class="section">
    <SkAnimtaion :article="true" v-if="loading"/>
    <div class="notFound" v-else-if="!detail">
      <img src="../assets/not-found.png">
      <h4>404</h4>
      <h2>Halaman tidak ditemukan</h2>
      <p>We can't find the page you looking for</p>
    </div>
    <div v-else>
      <Header :category="detail.category"/>
      <div class="articleDetail" v-on:click="showHeader"
        :class="detail.type">
        <div class="articleHeader" :class="{hideHeader: hideHeader}">
          <div class="ahL">
            <a :href="contentUri" target="_blank">
              <h2 class="articleTitle">{{detail.title}}</h2>
              <div class="publishTime">
                {{detail.publishDate | moment('MMM YYYY')}}
                <span class="bull">&bull;</span>
                {{detail.viewCountStr}} views
                <span class="bull">&bull;</span>
                <span class="category">{{detail.category.name}}</span>
              </div>
            </a>
          </div>
        </div>
        <div class="articleContent" v-if="detail.type === 'pdf'">
          <div id="dfCnt"></div>
        </div>
        <div class="articleContent image" v-else-if="detail.type === 'image'">
          <div class="theImg" :style="{'background-image': `url(${detail.imageLg})`}"></div>
        </div>
        <div class="articleContent video" v-else-if="detail.type === 'video'">
          <VuePlyr ref="video" :options="{ hideControls: false }">
            <video></video>
          </VuePlyr>
        </div>
        <div class="articleContent audio" v-else-if="detail.type === 'audio'">
          <VuePlyr ref="audio" :options="{ hideControls: false }">
            <video></video>
          </VuePlyr>
        </div>
        <div class="articleContent video youtube" v-else-if="detail.type === 'youtube'">
          <iframe :src="detail.embedUri" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media;
            gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="articleContent html" v-else-if="detail.type === 'html' && detail.htmlContent"
          v-html="detail.htmlContent.html"></div>
      </div>
      <div class="preview" v-if="detail.status === 'pending'">
        This is a preview, content will be published at
        <b>{{detail.publishDate | moment('dddd, D MMM YYYY HH:mm')}}</b></div>
    </div>
    <ShareDialog ref="shareDialog"/>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import SkAnimtaion from '@/components/SkAnimtaion.vue';
import Header from '@/components/Header.vue';
import ShareDialog from '@/components/ShareDialog.vue';

export default {
  name: 'read',
  components: {
    SkAnimtaion,
    Header,
    ShareDialog,
    VuePlyr,
  },
  data() {
    return {
      loading: true,
      detail: null,
      hideHeader: false,
      hhTimer: null,
      contentUri: '',
    };
  },
  methods: {
    showHeader() {
      if (this.hhTimer) clearTimeout(this.hhTimer);
      this.hideHeader = false;
      this.hhTimer = setTimeout(() => {
        this.hideHeader = true;
      }, 3000);
    },
    getData() {
      this.loading = true;
      const key = (this.$route.query.key) ? `&key=${this.$route.query.key}` : '';
      const detailUri = `content/${this.$route.params.slug}?session=${this.sessionId}${key}`;
      this.$http.get(this.$config.uri(detailUri)).then((r) => {
        this.detail = (r.data.status === 200) ? r.data.data : null;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        document.title = (r.data.status === 200)
          ? `${this.detail.title} - ${this.$config.appName}`
          : `Content Not Found - ${this.$config.appName}`;
        this.loading = false;
        this.contentUri = `${this.$config.appUri}${this.detail.category.slug}/${this.detail.slug}`;
        this.showHeader();
        if (this.detail.type === 'pdf') {
          setTimeout(() => {
            $('#dfCnt').flipBook(this.detail.pdf, {
              backgroundColor: '#ede6d4',
              scrollWheel: false,
              height: $(window).height(),
              hideControls: 'share,download',
              onFlip: (fb) => {},
              onReady: (fb) => {
                if (this.$route.query.p) {
                  setTimeout(() => {
                    fb.gotoPage(this.$route.query.p);
                  }, 1200);
                }
              },
            });
          }, 500);
        } else if (this.detail.type === 'video') {
          const src = [];
          if (this.detail.vid1080p) src.push({ src: this.detail.vid1080p, type: 'video/mp4', size: 1080 });
          if (this.detail.vid720p) src.push({ src: this.detail.vid720p, type: 'video/mp4', size: 720 });
          if (this.detail.vid480p) src.push({ src: this.detail.vid480p, type: 'video/mp4', size: 480 });
          if (this.detail.vid360p) src.push({ src: this.detail.vid360p, type: 'video/mp4', size: 360 });
          setTimeout(() => {
            const v = this.$refs.video.player;
            v.source = { type: 'video', title: this.detail.title, sources: src };
            v.play();
          });
        } else if (this.detail.type === 'audio') {
          const src = [{ src: this.detail.audio, type: this.detail.mimetype }];
          setTimeout(() => {
            const v = this.$refs.audio.player;
            v.source = { type: 'audio', title: this.detail.title, sources: src };
            v.play();
          });
        }
      });
    },
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = `Loading Content - ${this.$config.appName}`;
    this.getData();
  },
};
</script>

<style lang="scss">
.preview{
  position: fixed;
  z-index: 991;
  left: 0; right: 0; bottom: 0;
  padding: 10px 0;
  text-align: center;
  background-color: yellow;
  color: #222;
}
#dfCnt{
  height: calc(100vh - 183px);
  background-color: #f5f5f5;
  @media (max-width: 980px) {
    height: calc(100vh - 164px);
  }
}
.articleContent{
  &.image{
    position: fixed;
    left: 0; top: 0; right: 0; bottom: 0;
    z-index: 3;
    background-color: #444;
    .theImg{
      position: absolute;
      left: 40px; top: 40px; right: 40px; bottom: 40px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  &.video{
    position: fixed;
    left: 0; top: 0; right: 0; bottom: 0;
    z-index: 3;
    background-color: #000;
    &.youtube{
      iframe{
        width: 100%; height: 100%;
      }
    }
  }
  &.audio{
    position: fixed;
    left: 0; top: 0; right: 0; bottom: 0;
    z-index: 3;
    background-color: #f5f5f5;
    display: flex;
    .plyr{
      margin-top: auto;
      width: 100%; height: auto;
    }
  }
  &.html{
    position: fixed;
    left: 0; top: 0; right: 0; bottom: 0;
    z-index: 3;
    background-color: #fff;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.sectionTitle{
  font-size: 32px;
  line-height: 1.3;
  margin: 0 auto 10px;
  max-width: 1180px;
  @media (max-width: 1300px) {
    max-width: 1140px;
  }
  @media (max-width: 1220px) {
    margin: 0 20px 10px;
  }
  @media (max-width: 680px) {
    margin: 0 16px 10px;
    font-size: 20px;
  }
}
.allContentCnt{
  padding-top: 40px;
  padding-bottom: 20px;
  .allContent{
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      margin: 0 20px;
    }
    @media (max-width: 680px) {
      margin: 0 16px;
    }
    .contentCnt{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
      @media (max-width: 680px) {
        margin: 0 -8px;
      }
    }
    .contentItem{
      width: calc(20% - 20px);
      margin: 0 10px 40px;
      @media (max-width: 680px) {
        width: calc(50% - 16px);
        margin: 0 8px 40px;
      }
      a{
        color: #444;
        text-decoration: none;
      }
      .contentImg{
        height: 400px;
        border-radius: 2px;
        margin-bottom: 14px;
        position: relative;
        overflow: hidden;
        @media (max-width: 1300px) {
          height: 380px;
        }
        @media (max-width: 1220px) {
          height: 32vw;
        }
        @media (max-width: 680px) {
          height: 78vw;
        }
        &.shortImg{
          height: 300px;
          @media (max-width: 1300px) {
            height: 280px;
          }
          @media (max-width: 1220px) {
            height: 22vw;
          }
          @media (max-width: 680px) {
            height: 68vw;
          }
        }
        .theImg{
          position: absolute;
          top: -2px; right: -2px; bottom: -2px; left: -2px;
          background-position: center;
          background-size: cover;
          background-color: #f5f5f5;
          &.noImg{
            background-color: #ccc;
            background-image: url(../assets/image-white.png) !important;
            background-position: center;
            background-size: 64px auto;
            background-repeat: no-repeat;
          }
          .lnk{
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            z-index: 2;
          }
        }
      }
      .contentInfo{
        position: relative;
        padding: 0 40px 0 5px;
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 0; top: 0;
          background-image: url(../assets/heart.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          &:hover{
            // background-color: #fff1f1;
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          color: #767676;
          font-size: 12px;
          font-weight: bold;
          a{
            color: #767676;
          }
        }
        h4{
          margin: 3px 0 6px;
          font-size: 18px;
          line-height: 1.2;
          @media (max-width: 1340px) {
            font-size: 17px;
          }
        }
        .date{
          margin-top: 4px;
          font-size: 14px;
          color: #767676;
          a{
            color: #767676;
          }
        }
      }
    }
  }
}


  .articleDetail{
    .articleHeader{
      display: flex;
      margin: 0 auto;
      padding-bottom: 20px;
      position: relative;
      position: fixed;
      left: 0; right: 0; top: 0;
      z-index: 991;
      padding: 12px 10px 100px 20px;
      background-image: linear-gradient(rgba(255, 255, 255, .8), transparent);
      transition: all .7s ease;
      a{
        color: #444;
      }
      &.hideHeader{
        top: -180px;
      }
      .ahL{
        margin-right: auto;
        .articleTitle{
          font-size: 30px;
          margin: 0;
          display: block;
          @media (max-width: 680px) {
            font-size: 22px;
            margin: 0 0 2px;
          }
        }
        .publishTime{
          @media (max-width: 680px) {
            font-size: 14px;
          }
          .bull{
            margin: 0 12px 0 10px;
            color: #999;
          }
          .category{
            text-transform: uppercase;
            font-weight: 500;
            color: #555;
          }
        }
      }
      .ahR{
        display: flex;
        align-items: center;
        @media (max-width: 680px) {
          margin-top: 2px;
          margin-left: -12px;
        }
        .articleAction{
          margin-left: 10px;
          position: relative;
          padding: 10px 16px;
          padding-left: 44px;
          border-radius: 50px;
          cursor: pointer;
          transition: all .3s ease;
          color: #444;
          @media (max-width: 680px) {
            font-size: 15px;
            margin: 0;
            padding-left: 40px;
            padding-top: 6px;
            padding-bottom: 6px;
          }
          &:hover{
            background-color: #eee;
          }
          &:before{
            width: 20px; height: 20px;
            content: "";
            position: absolute;
            left: 14px; top: 9px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            @media (max-width: 680px) {
              width: 16px;
              top: 5px;
            }
          }
          &.share{
            &:before{
              background-image: url(../assets/share.png);
            }
          }
          &.download{
            &:before{
              background-image: url(../assets/download-icon.png);
            }
          }
          &.views{
            &:before{
              background-image: url(../assets/eye.png);
            }
          }
        }
      }
    }
    &.video{
      .articleHeader{
        background-image: linear-gradient(rgba(0, 0, 0, .8), transparent);
        color: #fff;
        a{
          color: #fff;
        }
        .publishTime{
          .bull{
            color: #fff;
          }
          .category{
            color: #fff;
          }
        }
      }
    }
  }
</style>
